// src/components/DisplayTickets.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import TicketCard from './TicketCard';
import { loader } from '../assets';

const DisplayTickets = ({ title, isLoading, tickets }) => {
  const navigate = useNavigate();

  const handleNavigate = (ticket) => {
    navigate(`/ticket-details/${ticket.id}`, { state: ticket }); // Use ticket.id in the URL
  };

  return (
    <div>
      <h1 className="font-epilogue font-semibold text-[18px] text-white text-left">
        {title} ({tickets.length})
      </h1>
      <div className="flex flex-wrap mt-[20px] gap-[26px]">
        {isLoading && (
          <img src={loader} alt="loader" className="w-[100px] h-[100px] object-contain" />
        )}
        {!isLoading && tickets.length === 0 && (
          <p className="font-epilogue font-semibold text-[14px] leading-[30px] text-[#818183]">
            You have not created any campaigns yet
          </p>
        )}
        {!isLoading &&
          tickets.length > 0 &&
          tickets.map((ticket) => (
            <TicketCard
              key={ticket.id}
              {...ticket}
              handleClick={() => handleNavigate(ticket)}
            />
          ))}
      </div>
    </div>
  );
};

export default DisplayTickets;